import { Campaign } from '../../model/campaign'

const mapMsFormsUrl = (rawData: any) => {
  return rawData.MSFormsUrl || rawData.MsFormsUrl || rawData.msFormsUrl || ''
}

const mapOwners = (rawOwners: unknown): string[] => {
  if (typeof rawOwners !== 'string' || !rawOwners.trim()) {
    return []
  }
  return rawOwners
    .split(',')
    .map((owner) => owner.trim())
    .filter(Boolean)
}

export const mapCampaignFromRawData = (rawData: any): Campaign => ({
  entryId: rawData.EntryId,
  title: rawData.Title,
  status: rawData.Status,
  countries: JSON.parse(rawData.Countries || '[]'),
  subRoles: JSON.parse(rawData.SubRoles || '[]'),
  fillingType: rawData.FillingType,
  period: {
    from: new Date(rawData.PeriodStart),
    to: new Date(rawData.PeriodEnd),
  },
  objectives: rawData.Objectives,
  msFormsUrl: mapMsFormsUrl(rawData),
  owners: mapOwners(rawData.Owners),
  created: rawData.Created,
  createdBy: rawData.CreatedBy,
  modified: rawData.Modified,
  modifiedBy: rawData.ModifiedBy,
})
